export default "__VITE_ASSET__DFmS8hDJ__"